import { render, staticRenderFns } from "./vipFw.vue?vue&type=template&id=22d402f6&scoped=true"
import script from "./vipFw.vue?vue&type=script&lang=js"
export * from "./vipFw.vue?vue&type=script&lang=js"
import style0 from "./vipFw.vue?vue&type=style&index=0&id=22d402f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d402f6",
  null
  
)

export default component.exports